import * as $ from 'jquery';

$(() => {
    const settingsPageContainer = $('[data-organization-settings-page]');

    if (settingsPageContainer.length === 0) {
        return;
    }

    let container = $(settingsPageContainer[0]);
});